/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_View_AllInputs */

const cs_dashboard_view_all = /** @type {(inputs: Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit vše`)
};

const en_dashboard_view_all = /** @type {(inputs: Dashboard_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all`)
};

/**
* | output |
* | --- |
* | "View all" |
*
* @param {Dashboard_View_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_view_all = /** @type {((inputs?: Dashboard_View_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_View_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_view_all(inputs)
	return cs_dashboard_view_all(inputs)
});